import styled from 'styled-components';

export const Section = styled.div`
  margin: 0 auto;
  max-width: 1100px;
  width: 90%;
`;
